import _ from 'lodash';
import CONSTANT from '../../constant';
import { editingTarget } from '../mscratch/ext';

class ConnectService {

    constructor() {
        this.connectFilter = new Map()
            .set(CONSTANT.CONNECT_TYPE.SERIAL, this.filterSerial)
            .set(CONSTANT.CONNECT_TYPE.BLE, this.filterBle);
    }

    /**
     * 串口筛选
     * @param {*} data 串口数据
     * @param {*} option 筛选字段
     */
    filterSerial = (data, option) => {
        const filterData = this.filterSerialByOption(data, option);
        const newFilterData = this.filterSerialBySystem(filterData);
        return newFilterData;
    }

    /**
     * 串口根据option筛选
     * @param {*} data 串口数据
     * @param {*} option 筛选字段
     */
    filterSerialByOption(data, option) {
        const vendorId = option.vendorId && option.vendorId.toLowerCase();
        const manufacturer = option.manufacturer && option.manufacturer.toLowerCase();
        // 根据vendorID进行联想，生成对应的16进制字符串等
        let extVendorIds = [];
        if (_.isString(vendorId)) {
            extVendorIds.push(vendorId);
            // 解析成整数
            const intVal = parseInt(vendorId);
            if (!isNaN(intVal)) {
                extVendorIds.push(intVal);
            }
            // 去掉0x
            if (vendorId.startsWith('0x')) {
                extVendorIds.push(vendorId.replace('0x', ''));
            }
        } else {
            extVendorIds.push(vendorId.toString());
            extVendorIds.push(vendorId);
            if (_.isNumber(vendorId)) {
                let strVal16 = vendorId.toString(16);
                extVendorIds.push(strVal16);
                extVendorIds.push(`0x${strVal16}`);
            }
        }

        return _.filter(data, (o) => {
            const condition = extVendorIds.indexOf(o.vendorId.toLowerCase()) !== -1 || extVendorIds.indexOf(o.productId.toLowerCase()) !== -1;
            if (manufacturer) {
                return condition || o.manufacturer.toLowerCase().indexOf(manufacturer) !== -1;
            }
            return condition;
        });
    }

    /**
     * 筛选系统自带串口
     * @param {*} data 串口数据
     * @param {*} vendorId vendorId
     */
    filterSerialBySystem(data) {
        const reg = /tty\.usbserial-/g;
        const filterData = [];
        data.forEach((a) => {
            const { comName } = a;
            if (reg.test(comName)) {
                const temp = comName.replace(reg, 'tty.wchusbserial');
                const tempArr = data.filter((b) => b.comName === temp);
                if (tempArr.length === 0) {
                    filterData.push(a);
                }
            } else if (_.indexOf(filterData.map((c) => c.comName), comName) === -1) {
                filterData.push(a);
            }
        });
        return filterData;
    }

    /**
     * 蓝牙筛选
     * @param {*} data 蓝牙数据
     * @param {*} option 筛选字段
     */
    filterBle = (data, option) => {
        let { localName } = option;
        if(!localName) {
            return this.sortBle(data);
        }
        const filterData = _.filter(data, (o) => {
            return o.localName && o.localName.toLowerCase().indexOf(localName.toLowerCase()) !== -1;
        });
        return this.sortBle(filterData);
    }

    /**
     * 蓝牙排序
     * @param {*} data 串口数据
     * @param {*} option 筛选字段
     */
    sortBle(data) {
        const sortData = data.sort((a, b) => {
            if (a.rssi !== b.rssi) {
                return b.rssi - a.rssi;
            } else {
                return b.localName - a.localName;
            }
        });
        return sortData;
    }

    /**
     * 列表筛选
     * @param {*} type 连接类型
     * @param {*} data 数据
     */
    filterList(type, data) {
        const target = editingTarget();
        let option = null;
        try {
            option = target.config.options.connect[type];
        } catch (e) {
            console.log('connectServer filterList no options ', e);
            return data;
        }
        return this.connectFilter.get(type)(data, option) || data;
    }
}

export default new ConnectService();